import { Node } from '@tiptap/core';
import { classifyMedia } from 'features/dashboards/media';

/**
 * Two block nodes for text cards: an image, and an embed (a video player,
 * a Figma or Google document, or a link). Each holds only its address; the
 * read-only view draws them itself (RichText.jsx), and in the editor they
 * show as a labelled box.
 */
const label = (url) => {
  const m = classifyMedia(url);
  if (!m) return url;
  return `${m.kind === 'link' ? 'Link' : m.kind === 'image' ? 'Image' : m.provider} · ${url}`;
};

const mediaNode = (name) => Node.create({
  name,
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return { url: { default: null }, alt: { default: null } };
  },
  parseHTML() {
    return [{ tag: `div[data-media="${name}"]`, getAttrs: (el) => ({ url: el.getAttribute('data-url'), alt: el.getAttribute('data-alt') }) }];
  },
  renderHTML({ node }) {
    return ['div', { 'data-media': name, 'data-url': node.attrs.url, ...(node.attrs.alt ? { 'data-alt': node.attrs.alt } : {}), class: 'dash-media-box' }, label(node.attrs.url)];
  },
});

export const ImageNode = mediaNode('image');
export const EmbedNode = mediaNode('embed');
